import { RequestSorting } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { DropdownField, DropdownOption } from '@components/common/Fields/Dropdown';
import { t } from '@translations';

// TYPES
//--------

export type ProductRequestSortingProps = {
  onChange?: (sortingValue?: string) => void;
  isWorking?: boolean;
  productCount?: number;
  options?: DropdownOption<RequestSorting>[];
  sortValue?: string;
};

export const ProductRequestSorting = ({
  onChange,
  isWorking,
  productCount,
  options,
  sortValue,
}: ProductRequestSortingProps) => {
  const handleChange = (sortingValue?: string) => {
    if (typeof onChange === 'function' && sortingValue) {
      onChange(sortingValue);
    }
  };
  if (!onChange || (!isWorking && productCount === 0)) {
    return null;
  }

  return (
    <DropdownField
      label={t(TextCodes.Sorting.Sorting)}
      value={options?.find((option) => option.value === sortValue)?.label || ''}
      options={options || []}
      getValue={(value: string | string[]) => handleChange(value as string)}
    />
  );
};
